import { useRejectConsumer } from "@features/cx/consumerOnboarding/hooks";
import { toast } from "@shared/hooks/use-toast";
import { Button } from "@shared/ui/button";
import { Mail, FileText, XCircle } from "lucide-react";
import { useParams } from "react-router-dom";
import { EditApplicationDialog } from "../editConsumerInfo";

interface QuickActionsProps {
  onAddNote?: () => void;
  onSendCommunication?: () => void;
  consumerData?: any;
   onRefetch?: () => void;
}

const QuickActions = ({ onAddNote, onSendCommunication, consumerData ,onRefetch}: QuickActionsProps) => {
  const { consumerId, id } = useParams<{ consumerId: string, id: string }>();
  const { mutate: rejectConsumer } = useRejectConsumer();
  const consumerIdFromUrl = consumerId ? consumerId : id ? id : "";
  const handleReject = () => {
  rejectConsumer(consumerIdFromUrl, {
    onSuccess: () => {
      toast({
        title: "Application Rejected",
        description: "The consumer application has been rejected.",
      });
      onRefetch();
    },
    onError: () => {
      toast({
        title: "Failed",
        description: "Something went wrong.",
        variant: "destructive",
      });
    },
  });
};
  return (
    <div className="border rounded-xl p-4 bg-white flex flex-col">
      <h3 className="text-lg font-semibold mb-4">Quick Actions</h3>

      <div className="flex flex-col gap-3">
        <Button
          variant="ghost"
          onClick={onSendCommunication}
          className="w-full justify-start border bg-gray-50 hover:bg-gray-100 text-gray-900 rounded-lg"
        >
          <Mail className="h-4 w-4 mr-2" />
          Send Communication
        </Button>

        <Button
          variant="ghost"
          onClick={onAddNote}
          className="w-full justify-start border bg-gray-50 hover:bg-gray-100 text-gray-900 rounded-lg"
        >
          <FileText className="h-4 w-4 mr-2" />
          Add Notes
        </Button>

        <Button
          variant="ghost"
          onClick={handleReject}
          className="w-full justify-start border bg-red-50 hover:bg-red-100 text-red-600 rounded-lg"
        >
          <XCircle className="h-4 w-4 mr-2 text-red-600" />
          Reject Application
        </Button>

          <EditApplicationDialog consumerData={consumerData}   onSuccess={onRefetch}
/>
      </div>
    </div>
  );
};

export default QuickActions;
